import React from "react"
import { BoxProps, Image, ResponsiveValue, AspectRatio, ImageProps } from "@chakra-ui/react"
import { useImageResolver } from "@app/hooks/useImageResolver"

type Props = {
  image: any
  ratio?: ResponsiveValue<number>
  loading?: ImageProps["loading"]
} & BoxProps

const ResolvedImageResponsive: React.FC<Props> = ({ image, ratio = undefined, ...props }) => {
  const { resolvedImage: resolvedImageDesktop } = useImageResolver(image?.desktop)
  const { resolvedImage: resolvedImageMobile } = useImageResolver(image?.mobile)

  return ratio ? (
    <>
      <AspectRatio ratio={ratio} display={{ base: resolvedImageMobile ? "none" : "block", sm: "block" }}>
        <Image {...resolvedImageDesktop} {...props} />
      </AspectRatio>
      {resolvedImageMobile && (
        <AspectRatio ratio={ratio} display={{ base: "block", sm: "none" }}>
          <Image {...resolvedImageMobile} {...props} />
        </AspectRatio>
      )}
    </>
  ) : (
    <>
      <Image {...resolvedImageDesktop} {...props} display={{ base: resolvedImageMobile ? "none" : "block", sm: "block" }} />
      {resolvedImageMobile && <Image {...resolvedImageMobile} {...props} display={{ sm: "none" }} />}
    </>
  )
}

export default React.memo(ResolvedImageResponsive)
